export var USER_TEAMS_LOAD_REQUEST = 'USER_TEAMS_LOAD_REQUEST';
export var USER_TEAMS_LOAD_SUCCESS = 'USER_TEAMS_LOAD_SUCCESS';
export var USER_TEAMS_LOAD_FAILURE = 'USER_TEAMS_LOAD_FAILURE';
export var LOAD_NO_ACCESS_TEAMS_REQUEST = 'LOAD_NO_ACCESS_TEAMS_REQUEST';
export var LOAD_NO_ACCESS_TEAMS_SUCCESS = 'LOAD_NO_ACCESS_TEAMS_SUCCESS';
export var LOAD_NO_ACCESS_TEAMS_FAILURE = 'LOAD_NO_ACCESS_TEAMS_FAILURE';
export var USER_TEAM_CHANGE = 'USER_TEAM_CHANGE';